import {
    NOTIFICATION_DATA, 
    NOTIFICATION_GET_DATA,
    NOTIFICATION_FORM_ADD_DATA,
    NOTIFICATION_UPDATE_DATA,
    NOTIFICATION_DELETE_DATA,
    NOTIFICATION_AUDIT_GET_DATA,
} from './Constants'

// get all Notification
const loadNotificationDataRequest = () => ({
  type: NOTIFICATION_DATA.NOTIFICATION_DATA_LOAD,
});
const setNotificationDataSuccess = (notification) => ({
  type: NOTIFICATION_DATA.NOTIFICATION_DATA_SUCCESS,
  notification,
});
const setNotificationDataFail = (error) => ({
  type: NOTIFICATION_DATA.NOTIFICATION_DATA_FAIL,
  error,
});

//Get by id
const loadNotificationGetDataRequest = (id) => ({
  type: NOTIFICATION_GET_DATA.NOTIFICATION_GET_DATA_LOAD,
  id,
});

const setNotificationGetDataSuccess = (notify) => ({
  type: NOTIFICATION_GET_DATA.NOTIFICATION_GET_DATA_SUCCESS,
  notify,
});

const setNotificationGetDataFail = (error) => ({
  type: NOTIFICATION_GET_DATA.NOTIFICATION_GET_DATA_FAIL,
  error,
});

//Get by id audit data
const loadNotificationAuditGetDataRequest = (id) => ({
  type: NOTIFICATION_AUDIT_GET_DATA.NOTIFICATION_AUDIT_GET_DATA_LOAD,
  id,
});

const setNotificationAuditGetDataSuccess = (audit) => ({
  type: NOTIFICATION_AUDIT_GET_DATA.NOTIFICATION_AUDIT_GET_DATA_SUCCESS,
  audit,
});

const setNotificationAuditGetDataFail = (error) => ({
  type: NOTIFICATION_AUDIT_GET_DATA.NOTIFICATION_AUDIT_GET_DATA_FAIL,
  error,
});

//For add  noti
const loadNotificationFormAddDataRequest = (request) => ({
  type: NOTIFICATION_FORM_ADD_DATA.NOTIFICATION_FORM_ADD_DATA_LOAD,
  request,
});
const setNotificationFormAddDataSuccess = (mynotify) => ({
  type: NOTIFICATION_FORM_ADD_DATA.NOTIFICATION_FORM_ADD_DATA_SUCCESS,
  mynotify,
});
const setNotificationFormAddDataFail = (error) => ({
  type: NOTIFICATION_FORM_ADD_DATA.NOTIFICATION_FORM_ADD_DATA_FAIL,
  error,
});


//For Edit Noti
const loadNotificationUpdateDataRequest = (request) => ({
  type: NOTIFICATION_UPDATE_DATA.NOTIFICATION_UPDATE_DATA_LOAD,
  request
})

const setNotificationUpdateDataSuccess = (mynotify) => ({
  type: NOTIFICATION_UPDATE_DATA.NOTIFICATION_UPDATE_DATA_SUCCESS,
  mynotify,
})

const setNotificationUpdateDataFail = (error) => ({
  type: NOTIFICATION_UPDATE_DATA.NOTIFICATION_UPDATE_DATA_FAIL,
  error
})

// Delete Noti
const loadNotificationDeleteDataRequest = (id) => ({
  type: NOTIFICATION_DELETE_DATA.NOTIFICATION_DELETE_LOAD,
  id,
});
const setNotificationDeleteDataSuccess = (notify) => ({
  type: NOTIFICATION_DELETE_DATA.NOTIFICATION_DELETE_SUCCESS,
  notify,
});

const setNotificationDeleteDataFail = (error) => ({
  type: NOTIFICATION_DELETE_DATA.NOTIFICATION_DELETE_FAIL,
  error,
});

export {
    
    loadNotificationDataRequest,setNotificationDataFail,setNotificationDataSuccess,
    loadNotificationGetDataRequest,setNotificationGetDataFail,setNotificationGetDataSuccess,
    loadNotificationFormAddDataRequest,setNotificationFormAddDataFail,setNotificationFormAddDataSuccess,
    loadNotificationUpdateDataRequest, setNotificationUpdateDataFail, setNotificationUpdateDataSuccess,
    loadNotificationDeleteDataRequest, setNotificationDeleteDataFail, setNotificationDeleteDataSuccess,
    loadNotificationAuditGetDataRequest, setNotificationAuditGetDataFail, setNotificationAuditGetDataSuccess
    
}